import { render, staticRenderFns } from "./mp-button-white.vue?vue&type=template&id=505d9cfc&scoped=true"
import script from "./mp-button-white.vue?vue&type=script&lang=js"
export * from "./mp-button-white.vue?vue&type=script&lang=js"
import style0 from "./mp-button-white.vue?vue&type=style&index=0&id=505d9cfc&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505d9cfc",
  null
  
)

export default component.exports